// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"TechnicalWorks_wrapper__1svv1","message":"TechnicalWorks_message__9SK-J"};